module.exports = __webpack_public_path__ + "img/sccm-logo.67b58112.svg";